import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

function AdminSetup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const createAdminUser = httpsCallable(functions, 'createAdminUser');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    // Client-side validation
    if (!email || !password) {
      setMessage('Error: Email and password are required');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setMessage('Error: Password must be at least 6 characters');
      setLoading(false);
      return;
    }

    console.log('Attempting to create admin user with:', { email, password: '***' });

    try {
      const result = await createAdminUser({ email, password });
      console.log('Admin user creation result:', result);
      setMessage(`Success: ${result.data.message}`);
      setEmail('');
      setPassword('');
    } catch (error) {
      console.error('Admin user creation error:', error);
      setMessage(`Error: ${error.message || 'Failed to create admin user'}`);
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      maxWidth: '400px', 
      margin: '50px auto', 
      padding: '20px', 
      border: '2px solid #000',
      fontFamily: 'Futura'
    }}>
      <h2>ADMIN SETUP</h2>
      <p>Create the first admin user for the system.</p>
      
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #000',
              fontSize: '14px'
            }}
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #000',
              fontSize: '14px'
            }}
          />
        </div>
        
        <button 
          type="submit" 
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: '#000',
            color: '#fff',
            border: '2px solid #000',
            fontSize: '14px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'CREATING...' : 'CREATE ADMIN'}
        </button>
      </form>
      
      {message && (
        <div style={{ 
          marginTop: '15px', 
          padding: '10px', 
          background: message.startsWith('Success') ? '#d4edda' : '#f8d7da',
          border: `1px solid ${message.startsWith('Success') ? '#c3e6cb' : '#f5c6cb'}`,
          color: message.startsWith('Success') ? '#155724' : '#721c24',
          fontSize: '12px'
        }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default AdminSetup;
